import React, { createContext, useContext, useEffect, useState } from "react";
import "./App.css";
import EddForm from "./pages/EddForm";

declare global {
  interface Window {
    authToken: string | null;
  }
}

function App() {
  useEffect(() => {
    if (window?.authToken) {
      sessionStorage.setItem("authToken", window?.authToken ?? "");
    }
  }, []);

  return (
    <div className="min-h-screen">
      <EddForm />
    </div>
  );
}

export default App;
